import { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import Button from "./Button";

/*
  Figma "Alert": a 320 centred question on bg/overlay, the action full width
  and Cancel as Plain under it. For decisions that stop something.
*/
const Alert = ({ open, title, message, confirmLabel, cancelLabel, onConfirm, onClose, loading = false, tone = "danger", isDark }) => {
  const closeRef = useRef(onClose);
  closeRef.current = onClose;

  useEffect(() => {
    if (!open) return undefined;
    const onKeyDown = (event) => {
      if (event.key === "Escape") closeRef.current?.();
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [open]);

  if (!open) return null;

  return createPortal(
    <div
      data-theme={isDark === undefined ? undefined : isDark ? "dark" : "light"}
      className="fixed inset-0 z-[600] flex items-center justify-center p-space-24 font-ds text-label-primary"
    >
      <div className="absolute inset-0 bg-overlay-scrim" onClick={() => !loading && onClose?.()} aria-hidden="true" />
      <div
        role="alertdialog"
        aria-modal="true"
        aria-label={title}
        className="relative flex w-full max-w-[320px] flex-col gap-space-8 rounded-radius-lg bg-bg-overlay p-space-20 text-center shadow-overlay"
      >
        <h2 className="text-headline">{title}</h2>
        <p className="text-subheadline text-label-secondary">{message}</p>
        <div className="mt-space-8 flex flex-col gap-space-8">
          <Button variant={tone === "danger" ? "danger" : "filled"} fullWidth loading={loading} onClick={onConfirm}>
            {confirmLabel}
          </Button>
          <Button variant="plain" fullWidth disabled={loading} onClick={onClose}>
            {cancelLabel}
          </Button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default Alert;
